/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsUnsubscribeRequest
 */
export interface NotificationsUnsubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnsubscribeRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnsubscribeRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the NotificationsUnsubscribeRequest interface.
 */
export function instanceOfNotificationsUnsubscribeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function NotificationsUnsubscribeRequestFromJSON(json: any): NotificationsUnsubscribeRequest {
    return NotificationsUnsubscribeRequestFromJSONTyped(json, false);
}

export function NotificationsUnsubscribeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsUnsubscribeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function NotificationsUnsubscribeRequestToJSON(value?: NotificationsUnsubscribeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'reason': value.reason,
    };
}

